export const TEMPLATE_CONSTANT = {
  PERSONAL_DATA_CARD_TITLE: 120,
  PERSONAL_DATA_CARD_SUBTITLE: 121,
  PAYMENT_CARD_TITLE: 122,
  PAYMENT_CARD_SUBTITLE: 123,
  WIDGET_ANYONE_LABEL: 126,
  WIDGET_NEXT_BUTTON: 128,
  WIDGET_PREVIOUS_BUTTON: 129,
  WIDGET_BOOK_BUTTON: 130,
  WIDGET_CHOOSE_DESIRED_DATE_LABEL: 132,
  WIDGET_IN_STORE_LABEL: 168,
  WIDGET_EMAIL_PLACEHOLDER: 169,
  WIDGET_WHERE_SHOULD_THE_MEETING_TAKE_PLACE: 203,
  WIDGET_COMBINED_BOOKING_TEXT: 212,
  WIDGET_PRENAME_LABEL_TEMPLATE: 220,
  WIDGET_LASTNAME_LABEL_TEMPLATE: 221,
  WIDGET_EMAIL_LABEL_TEMPLATE: 222,
  WIDGET_PHONENUMBER_LABEL_TEMPLATE: 223,
  WIDGET_NO_POSSIBLE_APPOINTMENTS_HINT: 241,
  WIDGET_CAPTCHA_TEXT: 242,
  SHOW_MOBILE_ON_WIDGET: 263,
  WIDGET_WAITING_LIST_HINT: 268,
  WIDGET_MEETING_TYPES_LABEL: 307,
  WIDGET_BIRTHDAY_LABEL_TEMPLATE: 322,
  ERROR_MESSAGE_PHISHING_LINKS_INPUT: 326,
  WIDGET_MESSAGE_BOOKING_QUESTION_TABLE_TEMPLATE: 327,
  WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE: 328,
  WIDGET_DISCOUNT_CODE_APPLY_TEXT: 338,
  WIDGET_APPLY_COUPON_BUTTON: 339,
  WIDGET_COUPON_PLACEHOLDER: 340,
  WIDGET_COUPON_REDEEM_TEXT: 341,
  SMART_WIDGET_SUMMERY_STEP_BACK_BUTTON_TEXT: 344,
  WIDGET_CREDIT_CARD_LABEL: 348
};